import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { navigation } from '../../data/siteContent';

function SiteHeader({ detailLink }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (!isMenuOpen) {
      return undefined;
    }

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isMenuOpen]);

  return (
    <div className="sticky top-0 z-30 border-b border-white/10 bg-forest-950/85 backdrop-blur-md">
      <div aria-hidden="true" className="h-0.5 w-full bg-gradient-to-r from-sand-300 via-forest-300 to-sand-200" />
      <a
        className="sr-only absolute left-4 top-2 z-40 rounded-full bg-forest-700 px-4 py-2 text-sm font-semibold text-cream-100 focus:not-sr-only"
        href="#hovedinnhold"
      >
        Hopp til innhold
      </a>
      <div className="flex w-full items-center justify-between gap-4 py-4 pl-4 pr-4 sm:pl-6 sm:pr-8 lg:pl-8 lg:pr-12">
        <Link
          className="group flex items-center gap-2.5 no-underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-200 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950"
          to="/"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-sand-300 to-forest-300 text-base font-bold text-forest-950 shadow-lg transition group-hover:scale-105">
            O
          </span>
          <span className="text-base font-bold uppercase tracking-[0.16em] text-cream-100">
            OmsorgBygg<span className="text-sand-300">.no</span>
          </span>
        </Link>
        {detailLink ? (
          <Link
            className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-5 py-2.5 text-sm font-semibold text-cream-100 no-underline transition hover:bg-white/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-200 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950"
            to={detailLink}
          >
            <span aria-hidden="true">←</span> Tilbake til oversikten
          </Link>
        ) : (
          <>
            <nav aria-label="Hovednavigasjon" className="hidden items-center gap-1 md:flex">
              {navigation.map((item) => (
                <a
                  className="group relative px-3.5 py-2 text-sm font-semibold text-cream-200/85 no-underline transition hover:text-cream-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-200 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950 after:pointer-events-none after:absolute after:bottom-1 after:left-3.5 after:right-3.5 after:h-0.5 after:origin-left after:scale-x-0 after:rounded-full after:bg-gradient-to-r after:from-sand-300 after:to-forest-300 after:transition-transform after:duration-300 hover:after:scale-x-100"
                  href={item.href}
                  key={item.href}
                >
                  {item.label}
                </a>
              ))}
              <a
                className="focus-ring group ml-3 inline-flex items-center gap-2 overflow-hidden rounded-full bg-cream-100 px-5 py-2.5 text-sm font-bold text-forest-900 no-underline shadow-lg transition hover:-translate-y-0.5 hover:bg-white hover:shadow-xl focus-visible:ring-2 focus-visible:ring-cream-200 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950"
                href="#kontakt"
              >
                Kontakt oss
                <span aria-hidden="true" className="transition group-hover:translate-x-0.5">→</span>
              </a>
            </nav>
            <button
              aria-controls="mobil-meny"
              aria-expanded={isMenuOpen}
              aria-label={isMenuOpen ? 'Lukk meny' : 'Åpne meny'}
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-white/10 text-cream-100 transition hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-200 focus-visible:ring-offset-2 focus-visible:ring-offset-forest-950 md:hidden"
              onClick={() => setIsMenuOpen((open) => !open)}
              type="button"
            >
              <span aria-hidden="true" className="text-lg">
                {isMenuOpen ? '✕' : '☰'}
              </span>
            </button>
          </>
        )}
      </div>
      {!detailLink && isMenuOpen ? (
        <nav
          aria-label="Mobilnavigasjon"
          className="site-rail pb-4 md:hidden"
          id="mobil-meny"
        >
          <div className="grid gap-1 rounded-2xl border border-white/10 bg-forest-900/80 p-2">
            {navigation.map((item) => (
              <a
                className="rounded-xl px-4 py-3 text-sm font-semibold text-cream-200 no-underline transition hover:bg-white/10 hover:text-cream-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cream-200"
                href={item.href}
                key={item.href}
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a
              className="mt-1 rounded-xl bg-cream-100 px-4 py-3 text-center text-sm font-bold text-forest-900 no-underline transition hover:bg-white"
              href="#kontakt"
              onClick={() => setIsMenuOpen(false)}
            >
              Kontakt oss
            </a>
          </div>
        </nav>
      ) : null}
    </div>
  );
}

export default SiteHeader;